import { ApiRoutes } from "@/enums/apiRoutes.enum";
import axios from "@/lib/axios";
import { Store, StoreWritePayload } from "@/types/data";

const byId = (id: string) =>
  `${ApiRoutes.STORES}/${encodeURIComponent(id)}`;

export const storeService = {
  async getAll(): Promise<Store[]> {
    const response = await axios.get<Store[]>(ApiRoutes.STORES);
    return response.data;
  },

  async create(payload: StoreWritePayload): Promise<Store> {
    const response = await axios.post<Store>(ApiRoutes.STORES, payload);
    return response.data;
  },

  // :id is the ime_ducana; send only the fields that changed.
  async update(id: string, payload: StoreWritePayload): Promise<Store> {
    const response = await axios.put<Store>(byId(id), payload);
    return response.data;
  },

  // :id is the ime_ducana; 204 No Content on success.
  async delete(id: string): Promise<void> {
    await axios.delete(byId(id));
  },
};
